module.exports = __webpack_public_path__ + "media/images/emblems/Laupersdorf-blason-cba8738de94b379f17e6dee0c9694f69.png";